// AMFI component styles

// Color scheme from memory
export const AMFI_COLORS = {
	attribute: {
		main: '#27A4F9', // Sky blue
		bg: 'rgba(39, 164, 249, 0.2)',
	},
	metric: {
		main: '#008077', // Pine green
		bg: 'rgba(0, 128, 119, 0.2)',
	},
	fact: {
		main: '#F7BD00', // Goldenrod
		bg: 'rgba(247, 189, 0, 0.2)',
	},
	insight: {
		main: '#5759EE', // Indigo
		bg: 'rgba(87, 89, 238, 0.2)',
	},
};

// Styles for the AMFIItem component
export const amfiItemStyles = {
	item: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: '16px',
		borderRadius: '4px',
		overflow: 'hidden',
		boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
		position: 'relative',
	},
	itemHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '8px 12px',
		fontWeight: 'bold',
	},
	itemContent: {
		padding: '12px 16px',
		backgroundColor: 'white',
	},
	itemFooter: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '8px 12px',
		borderTop: '1px solid rgba(0, 0, 0, 0.05)',
		backgroundColor: 'white',
		fontSize: '0.8rem',
		color: 'rgba(0, 0, 0, 0.6)',
	},
	actions: {
		display: 'flex',
		gap: '8px',
	},
	categoryChip: {
		fontSize: '0.75rem',
		padding: '2px 8px',
		borderRadius: '4px',
		backgroundColor: 'rgba(0, 0, 0, 0.08)',
		color: 'rgba(0, 0, 0, 0.7)',
	},
	// New styles for updated layout
	contentContainer: {
		padding: '12px 16px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
	},
	contentLeft: {
		flex: 1,
	},
	itemTitle: {
		fontWeight: 'bold',
		marginBottom: '8px',
	},
};

// Styles for the AMFIForm component
export const amfiFormStyles = {
	form: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		padding: '16px',
	},
	formActions: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: '8px',
		marginTop: '16px',
	},
	fieldGroup: {
		display: 'flex',
		gap: '16px',
	},
};

// Styles for the AMFIReclassify component
export const amfiReclassifyStyles = {
	dialog: {
		padding: '24px',
	},
	typeOptions: {
		display: 'flex',
		justifyContent: 'space-between',
		gap: '16px',
		marginTop: '16px',
		marginBottom: '24px',
	},
	typeOption: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '16px',
		borderRadius: '8px',
		cursor: 'pointer',
		width: '22%',
		transition: 'all 0.2s ease',
	},
	typeLabel: {
		marginTop: '8px',
		fontWeight: 'bold',
	},
	actions: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: '8px',
		marginTop: '16px',
	},
};
